module.exports = "/images/water park.svg?532488a95e322aae4a81fdcffb9acf8b";